// src/MapComponent.js
import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css';
import 'leaflet-defaulticon-compatibility';

// 居酒屋データの配列
const izakayas = [
  { id: 1, name: "発酵バー醸（かもす）", position: [36.643056099180775, 138.18793189802045], description: "長野駅にある日本酒飲み比べのできるバーです" },
  { id: 2, name: "酒場食堂ニューゴールデン", position: [36.64426175219125, 138.1870020924949], description: "大瓶が399円と安い店。上田の追いタレ焼き鳥や、山賊焼など長野の名物があります。" },
  { id: 3, name: "がばい寅次郎", position: [36.65085427900676, 138.1896973247732], description: "信州の日本酒の飲み放題、名物もあるお店" },
];

// 通常のマーカーアイコン
const defaultIcon = new L.Icon({
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

// 選択されたマーカーアイコン（色を変更）
const selectedIcon = new L.Icon({
    iconUrl: 'https://leafletjs.com/examples/custom-icons/leaf-red.png',
    shadowUrl: 'https://leafletjs.com/examples/custom-icons/leaf-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const MapComponent = ({ selectedIzakayaId }) => {
  return (
    <MapContainer center={[36.643137034940324, 138.18858243203726]} zoom={15} style={{ height: '500px', width: '100%' }}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {izakayas.map((izakaya) => (
        <Marker
          key={izakaya.id}
          position={izakaya.position}
          // アイコンの設定: 選択された居酒屋ならselectedIcon、それ以外はdefaultIcon
          icon={izakaya.id === selectedIzakayaId ? selectedIcon : defaultIcon}
        >
          <Popup>
            <strong>{izakaya.name}</strong><br />
            {izakaya.description}
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}

export default MapComponent;
